import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";
import RotatingCoin from "@/components/RotatingCoin";
import LanguageToggle from "@/components/LanguageToggle";

const Navbar = () => {
  const { t } = useI18n();

  const handleNavClick = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="sticky top-0 z-50 w-full glass border-b border-[rgba(212,175,55,0.12)]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-20 flex items-center justify-between">
        <a
          href="#top"
          onClick={handleNavClick("top")}
          data-testid="navbar-logo-link"
          className="flex items-center gap-3 group"
        >
          <RotatingCoin variant="small" size={56} testId="navbar-coin" />
          <div className="leading-tight">
            <div className="font-heading text-base sm:text-lg tracking-[0.2em] text-gold-bright">
              CLOUD GM
            </div>
            <div className="text-[11px] tracking-[0.3em] text-[var(--text-muted)] uppercase">
              Coin
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a
            href="#about"
            onClick={handleNavClick("about")}
            data-testid="nav-link-about"
            className="text-[var(--text-muted)] hover:text-[var(--gold-bright)] transition-colors"
          >
            {t.nav.about}
          </a>
          <a
            href="#vision"
            onClick={handleNavClick("vision")}
            data-testid="nav-link-vision"
            className="text-[var(--text-muted)] hover:text-[var(--gold-bright)] transition-colors"
          >
            {t.nav.vision}
          </a>
          <a
            href="#notify"
            onClick={handleNavClick("notify")}
            data-testid="nav-link-notify"
            className="text-[var(--text-muted)] hover:text-[var(--gold-bright)] transition-colors"
          >
            {t.nav.notify}
          </a>
        </nav>

        <LanguageToggle />
      </div>
      <div className="shimmer-line" aria-hidden />
    </motion.header>
  );
};

export default Navbar;
